<template>
	<div class="form-group" :class="className">
		<label class="form-label" v-show="label">{{ label }}</label>
		<select
			class="form-select"
			:class="{ active: model !== '' }"
			:id="'form-select-' + field.adPropertyKey"
			v-model="model"
			@change="updateFilter()"
		>
			<option value="">{{ placeholder }}</option>
			<template v-for="option in options" :key="option">
				<option
					v-if="showZero && option.count === 0"
					:value="option.adPropertyValue"
					:selected="option.adPropertyValue === model"
					:disabled="
						option.count === 0 &&
						disableZero &&
						option.adPropertyValue !== model
					"
				>
					{{ refData[option.adPropertyValue] }}
					<template
						v-if="this.$store.state.lastFilter === 'field.adPropertyKey'"
						>(0)</template
					>
				</option>
				<option
					v-else-if="option.count > 0"
					:value="option.adPropertyValue"
					:selected="option.adPropertyValue === model"
					:disabled="
						option.count === 0 &&
						disableZero &&
						option.adPropertyValue !== model
					"
				>
					{{ refData[option.adPropertyValue] }}
					<template v-if="option.count > 0"> ({{ option.count }})</template>
				</option>
			</template>
		</select>
	</div>
</template>

<script>
import store from '@/store'

export default {
	name: 'FormSelect',
	data() {
		return {
			model: '',
		}
	},
	props: {
		label: {
			type: String,
			default: '',
		},
		className: {
			type: String,
			default: '',
		},
		placeholder: {
			type: String,
			default: '- Alle -',
		},
		field: {
			type: Object,
			required: true,
		},
		refData: {
			type: Object,
			required: true,
		},
		showZero: {
			type: Boolean,
			required: false,
			default: true,
		},
		disableZero: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	computed: {
		options() {
			let hits = this.field.hits
			return hits.sort((a, b) =>
				a.adPropertyValue.toLowerCase() > b.adPropertyValue.toLowerCase()
					? 1
					: -1
			)
		},
	},
	methods: {
		updateFilter() {
			if (this.model !== '') {
				store.commit('updateFilter', {
					adPropertyKey: this.field.adPropertyKey,
					adPropertyType: this.field.adPropertyType,
					adPropertyValue: this.model,
				})
			} else {
				store.commit('deleteFilter', this.field.adPropertyKey)
			}
			this.$emit('updateFilter')
		},
	},
	created() {
		if (store.state.filterItems[this.field.adPropertyKey] !== undefined) {
			this.model =
				store.state.filterItems[this.field.adPropertyKey].adPropertyValue
		}

		this.unsubscribe = store.subscribe((mutation, state) => {
			if (
				mutation.type === 'deleteFilter' ||
				mutation.type === 'deleteAllFilter'
			) {
				if (
					state.filterItems[this.field.adPropertyKey] === undefined &&
					this.model !== ''
				) {
					this.model = ''
				}
			}
		})
	},
	beforeUnmount() {
		this.unsubscribe()
	},
}
</script>
